import { CommonModule } from '@angular/common';
import { Inject, ModuleWithProviders, NgModule } from '@angular/core';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { MstarCategoryColors } from '@ddt-web/config';
import { UserDataApi } from '@ddt-web/domain';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

import { SaveAndSubscribeModelPortfoliosEffects } from './+state/save-and-subscribe-model-portfolios/save-and-subscribe-model-portfolios.effects';
import { SavedModelPortfoliosEffects } from './+state/saved-model-portfolios/saved-model-portfolios.effects';
import { savedModelPortfoliosInitialState } from './+state/saved-model-portfolios/saved-model-portfolios.init';
import { savedModelPortfoliosReducer } from './+state/saved-model-portfolios/saved-model-portfolios.reducer';
import { SubscribedModelPortfoliosEffects } from './+state/subscribed-model-portfolios/subscribed-model-portfolios.effects';
import { subscribedModelPortfoliosInitialState } from './+state/subscribed-model-portfolios/subscribed-model-portfolios.init';
import { subscribedModelPortfoliosReducer } from './+state/subscribed-model-portfolios/subscribed-model-portfolios.reducer';
import { SavedAndSubscribedFactory } from './factories/saved-and-subscribed-factory';
import { UserDataHandlerService } from './services/store-data-loader.service';
import { UserDataService } from './services/user-data.service';

const baseProviders = [
	UserDataService,
	SavedModelPortfoliosEffects,
	SubscribedModelPortfoliosEffects,
	SaveAndSubscribeModelPortfoliosEffects,
	UserDataHandlerService,
	MstarCategoryColors,
	SavedAndSubscribedFactory
];

@NgModule({
	imports: [
		CommonModule,
		CwpNgFrameworkModule,
		StoreModule.forFeature('savedModelPortfolios', savedModelPortfoliosReducer, { initialState: savedModelPortfoliosInitialState }),
		StoreModule.forFeature('subscribedModelPortfolios', subscribedModelPortfoliosReducer, { initialState: subscribedModelPortfoliosInitialState }),
		EffectsModule.forFeature([SavedModelPortfoliosEffects, SubscribedModelPortfoliosEffects, SaveAndSubscribeModelPortfoliosEffects]),
		StoreDevtoolsModule.instrument({
			name: 'ddt-web blk-model-subscription-manager',
			maxAge: 25 // Retains last 25 states
		})
	]
})
export class BlkModelSubscriptionManagerModule {
	public static forRoot(userDataApi: any): ModuleWithProviders<BlkModelSubscriptionManagerModule> {
		return {
			ngModule: BlkModelSubscriptionManagerModule,
			providers: [...baseProviders, { provide: 'userDataApi', useExisting: userDataApi }]
		};
	}

	constructor(@Inject('userDataApi') private userDataApi: UserDataApi, private storeDataLoader: UserDataHandlerService) {
		// eslint-disable-next-line @nrwl/nx/workspace/killSubscriptionRule
		this.userDataApi.getAllJson().subscribe(getAllJson => {
			this.storeDataLoader.load(getAllJson);
		});
	}
}
